import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

// Lazy CRM pages
const CRMDashboard = lazy(() => import('../modules/crm/pages/Dashboard'));
const LeadsList = lazy(() => import('../modules/crm/pages/Leads/LeadsList'));
const ContactsList = lazy(() => import('../modules/crm/pages/Contacts/ContactsList'));
const OpportunitiesList = lazy(() => import('../modules/crm/pages/Opportunities/OpportunitiesList'));
const ActivitiesList = lazy(() => import('../modules/crm/pages/Activities/ActivitiesList'));

const Fallback = <div style={{ padding: 16 }}>Loading CRM…</div>;

const withSuspense = (el: JSX.Element) => <Suspense fallback={Fallback}>{el}</Suspense>;

/**
 * Returns a Fragment (<>…</>) containing ONLY <Route> elements.
 * Use like: {renderCRMRoutes(Protected)}
 */
export function renderCRMRoutes(
  Protected: ({ children }: { children: JSX.Element }) => JSX.Element
): JSX.Element {
  return (
    <>
      <Route path="/crm" element={withSuspense(<Protected><CRMDashboard /></Protected>)} />
      <Route path="/crm/leads" element={withSuspense(<Protected><LeadsList /></Protected>)} />
      <Route path="/crm/contacts" element={withSuspense(<Protected><ContactsList /></Protected>)} />
      <Route path="/crm/opportunities" element={withSuspense(<Protected><OpportunitiesList /></Protected>)} />
      <Route path="/crm/activities" element={withSuspense(<Protected><ActivitiesList /></Protected>)} />
    </>
  );
}
